import React from 'react'
import logoImg from '../images/logo.png';
import { Link } from 'react-router-dom';
import socialImg from '../images/social-icon.png';

export default function Footer() {
    return (
        <footer>
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-sm-6 col-xs-1">
                        <div class="de-flex-col">
                            <div class="de-flex-col">

                                <div id="logo">
                                    <Link to="/">

                                        <img alt="logo" class="logo-2" src={logoImg} />
                                    </Link>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-lg-5 offset-lg-1">
                        <div class="row">
                            <div class="col-lg-4 col-sm-6 col-xs-1">
                                <div class="widget">
                                    <h5>Marketplace</h5>
                                    <ul>
                                        <li><Link to="/collections">Collections</Link></li>
                                        <li><Link to="/">NFTs</Link></li>
                                        <li><Link to="/create-nft">Create NFT</Link></li>
                                        <li><Link to="/create-collection/options">Create Collection</Link></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-lg-4 col-sm-6 col-xs-1">
                                <div class="widget">
                                    <h5>Resources</h5>
                                    <ul>
                                        <li><a href="#sec">Help Center</a></li>
                                        <li><a href="#sec">Partners</a></li>
                                        <li><a href="#sec">Docs</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-4 col-sm-6 col-xs-1">
                                <div class="widget">
                                    <h5>BlockStar</h5>
                                    <ul>
                                        <li>
                                            <a rel="noreferrer" target="_blank" href="https://blockstar.site">Website</a>
                                        </li>
                                        <li>
                                            <a rel="noreferrer" target="_blank" href="https://blockstar.software/">AI</a>
                                        </li>
                                        <li>
                                            <a rel="noreferrer" target="_blank" href="https://blockstar.social/">Social</a>
                                        </li>
                                        <li>
                                            <a rel="noreferrer" target="_blank" href="https://blockstar.site/staking">Staking</a>
                                        </li>
                                        <li>
                                            <a rel="noreferrer" target="_blank" href="https://dex.blockstar.site/">DEX</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6 col-xs-1">
                        <div class="widget">
                            <h5>Join the community</h5>
                            <div class="social-icons">
                                <a target='_blank' rel="noreferrer" href="https://twitter.com/BlockStar_BST"><i class="fa fa-twitter fa-lg"></i></a>
                                <a target='_blank' rel="noreferrer" href="https://blockstar.social/BlockStar_Official">
                                    <img src={socialImg} height="34px" width="34px" className='p-2' alt='profile' />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="subfooter">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <a href="#sec">
                                <span class="copy">&copy; Copyright {new Date().getFullYear()} BlockStar | All Rights Reserved.</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
